<div class="page-section">
    <div class="page-section-header">
        <h2 class="page-section-title">SMS List (Last 50 Records)</h2>
    </div>
    <div class="page-section-body">
        <table class="table">
            <thead>
                <tr>
                    <th>Date</th>
                    <th>Phone</th>
                    <th>TAC</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let sms of sms_list">
                    <td>{{sms.timestamp | date: 'dd/MM/yyyy HH:mm:ss'}}</td>
                    <td>{{sms.mobile}}</td>
                    <td>{{sms.tac}}</td>
                </tr>
                <tr *ngIf="!sms_list || sms_list.length === 0">
                    <td colspan="3" class="text-center text-muted py-4" style="font-style: italic;">No SMS records found.</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
